import { Tooltip, TooltipLabel, TooltipPlacement } from '@dreryk/react-components';

import { appointmentsTranslationKeys } from '../../../../../translations';

import { StyledDiseaseItem } from './StyledDiseaseItem';

type DiseaseItemProps = {
   readonly code: string;
   readonly main: boolean;
   readonly name: string;
};

export const DiseaseItem = (props: DiseaseItemProps): JSX.Element => {
   return (
      <StyledDiseaseItem $main={props.main}>
         <Tooltip
            content={
               <div>
                  {props.main ? <TooltipLabel label={appointmentsTranslationKeys.mainDiagnosis} /> : null}
                  {props.name}
               </div>
            }
            placement={TooltipPlacement.TOP}
            testId={'disease'}
         >
            <>{props.code}</>
         </Tooltip>
      </StyledDiseaseItem>
   );
};
